import 'antd/lib/tree-select/style';
import 'antd/lib/tooltip/style';
import 'antd/lib/tree/style';

import '../VtxTreeSelect.less';